import { JobsLimitResponse } from "../app/shared/models/layout/bulk-operations/jobs-limit/JobsLimit";

export function response(): JobsLimitResponse {
    return {
        cmd: {
            success: false,
            errorMessages: ['An error occurred'],
            // params: {
            //     limitDetails: {
            //         inCreationState: 5,
            //         limit: 5
            //     }
            // }
        }
    };
}
